const translation = {
  daysInWeek: {
    Sat: 'Sat',
    Fri: 'Freitag',
    Thu: 'Donnerstag',
    Tue: 'Tue',
    Sun: 'Sonne',
    Mon: 'Mon',
    Wed: 'Mittwoch',
  },
  months: {
    August: 'August',
    March: 'März',
    January: 'Januar',
    June: 'Juni',
    July: 'Juli',
    November: 'November',
    September: 'September',
    April: 'April',
    February: 'Februar',
    May: 'Mai',
    December: 'Dezember',
    October: 'Oktober',
  },
  operation: {
    pickDate: 'Datum auswählen',
    ok: 'OK',
    cancel: 'Stornieren',
    now: 'Jetzt',
  },
  title: {
    pickTime: 'Wähle Zeit',
  },
  defaultPlaceholder: 'Wähle eine Zeit...',
}

export default translation
